import { toast } from "react-toastify";
import AsteriskSymbol from "../reusableComponents/AsteriskSymbol";
import DatePicker from 'react-datepicker';
import "../scss/dateAndTime.scss"

const DateAndTime = ({
    label, // Optional -> to show label
    required, // Optional -> to show asterisk,
    date, // to show selected date in the picker after selecting the date
    setDate, // to set the date after selecting the date
    time, // time to show after selecting the time
    setTime, //to set the time after selecting the time
    disableFuture, //this will show toast if user selects future date and time
    maxDate, //Optional to display until maxDate
    highlightDate = new Date(), // optional -> To highlight the date in the picker, by default will hight the current date
    isDisabled,
    minDate,
    onChange
}) => {
       const timeHandler = (timeValue, dateValue) => {
            let dateNewField = dateValue ? dateValue : date
            if (new Date().setHours(0, 0, 0, 0) == new Date(dateNewField).setHours(0, 0, 0, 0)) {
                var d = new Date();
                d.getHours();
                d.getMinutes();
                let str1 = timeValue
                let str2 = String(d.getHours() + ":" + d.getMinutes())
                str1 = str1.split(':');
                str2 = str2.split(':');
    
                const totalSeconds1 = Number(str1[0] * 3600 + str1[1] * 60);
                const totalSeconds2 = Number(str2[0] * 3600 + str2[1] * 60);
                if (totalSeconds1 > totalSeconds2 && disableFuture) {
                    toast.error( `${label? label: ""} Can't be Future Date & Time.`)
                    setTime("")
                } else {
                    if(onChange) {
                        onChange(dateValue, timeValue)
                    } else {
                        setTime(timeValue)
                    }
                }
            } else {
                if(onChange) {
                    onChange(dateValue, timeValue)
                } else {
                    setTime(timeValue)
                }
            }
    
        }
        
const clearDate = () => {
    if(!isDisabled) {
        setDate(null);
        setTime("")
    }
  };

        const handleDateChange = (date) => {
        if (date) {
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0')
            const dat1 = (date.getDate()).toString().padStart(2, '0')
            
            if(time) {
                timeHandler(time, `${year}-${month}-${dat1}`)
            } else {
                if(onChange) {
                    onChange(`${year}-${month}-${dat1}`)
                } else {
                    setDate(`${year}-${month}-${dat1}`)
                }
            }
            
        }
        
    }
    return <>
        <>
            {label && (
            <p className="align6Policy">
               {label} {required && (<AsteriskSymbol />)}
            </p>
            )}
            <div className="row">
                <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12" style={{ marginTop: "18px", marginLeft: "10px" }}>
                    <div className="d-flex align-items-center gap-2">
                        <DatePicker
                            selected={date}
                            className="align4_dataPolicy mb-0"
                            onChange={handleDateChange}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="Select a date"
                            maxDate={maxDate}
                            minDate={minDate}
                            highlightDates={highlightDate}
                            disabled={isDisabled}
                            showYearDropdown
                            showMonthDropdown
                            scrollableYearDropdown
                            yearDropdownItemNumber={100}
                            onKeyDown={(e) => e.preventDefault()}
                        />
                    </div>


                </div>
                
                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12" style={{ marginTop: "18px", marginLeft: "-10px" }}>
                    <div className="d-flex align-items-center gap-2">
                        <input
                            type="time"
                            className="align4_dataPolicy mb-0"
                            name="Time"
                            id="time"
                            placeholder="Select Time"
                            onChange={(e) => {
                                timeHandler(e.target.value)
                            }}
                            disabled={isDisabled}
                            value={time}
                            onKeyDown={(e) => e.preventDefault()}
                        />
                    
                    <span className="custom-clear" disabled={isDisabled} onClick={clearDate} title="Clear Date">
                            &times;
                        </span>
                        </div>
                </div>
            </div>
        </>
    </>
}
export default DateAndTime